import axios from "axios";
import { BuyerRequirementTypes } from "./buyerRequirement.types";
import { environment } from "../../environments/environment";

const API_BASE_NAME = `${environment.apiBaseUrl}`;

// ✅ Get All Buyer Requirements (Admin View)
export const getAllBuyerRequirementApi = async (): Promise<{
  data: BuyerRequirementTypes[];
}> => {
  const res = await axios.get(
    `${API_BASE_NAME}/buyer-requirement/get-all`
  );
  return res.data;
};

export const deleteBuyerRequirementApi = async (
  id: number
): Promise<any> => {
  try {
    const token = localStorage.getItem("token");

    const response = await axios.delete(
      `${API_BASE_NAME}/buyer-requirement/delete/${id}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error("Error deleting buyer requirement:", error);
    throw error;
  }
};


// ✅ Create Buyer Requirement
export const createBuyerRequirementApi = async (data: any) => {
  try {

    const token = localStorage.getItem("token");

    const response = await axios.post(
      `${API_BASE_NAME}/buyer-requirement/create`,
      data,
        {
          headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    return response.data;

  } catch (error) {
    console.error("Error creating buyer requirement:", error);
    throw error;
  }
};


// Add this function to your buyerRequirement.service.ts file

export const getExactMatchSellersApi = async (requirementId: number) => {
  try {
    const token = localStorage.getItem("token"); // or wherever you store your bearer token

    const response = await fetch(
      `${API_BASE_NAME}/buyer-requirement/exact-match/${requirementId}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}` // Bearer token pass kar rahe hain
        }
      }
    );

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error in getExactMatchSellersApi:", error);
    throw error;
  }
};


export const shareRequirementWithSellers = async (requirementId: number, sellerIds: number[]) => {
  try {
    const token = localStorage.getItem("token"); // or wherever you store your bearer token
    
    const response = await fetch(
      `${API_BASE_NAME}/admin/share-requirement`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          requirementId: requirementId,
          sellerIds: sellerIds
        })
      }
    );
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error in shareRequirementWithSellers:", error);
    throw error;
  }
};

export const getRequirementResponseSummaryApi = async (
  requirementId: number
) => {
  try {
    const token = localStorage.getItem("token"); // ya jaha se token lete ho

    const response = await axios.get(
      `${API_BASE_NAME}/buyer/requirement-response-summary/${requirementId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error("Error fetching response summary:", error);
    throw error;
  }
};

// ✅ Get All Buyer Enquiries (Admin)
export const getAllBuyerEnquiriesApi = async (): Promise<any> => {
  try {
    const token = localStorage.getItem("token");

    const response = await axios.get(
      `${API_BASE_NAME}/admin/buyer-enquiries`, // 👈 apna actual route confirm kar lena
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    return response.data;

  } catch (error) {
    console.error("Error fetching buyer enquiries:", error);
    throw error;
  }
};


export const respondRequirementApi = async (
  id: number,
  payload: { status: string }
): Promise<any> => {
  const token = localStorage.getItem("token");

  const res = await axios.put(
    `${API_BASE_NAME}/seller/respond-requirement/${id}`,
    payload,
    {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    }
  );

  return res.data;
};


export const adminRespondRequirementApi = async (data: {
  status: string;
  sellerId: number;
  requirementId: number;
}): Promise<any> => {
  const token = localStorage.getItem("token");

  const res = await axios.put(
    `${API_BASE_NAME}/admin/respond-requirement`,
    data,
    {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    }
  );

  return res.data;
};